import { getUserApi } from '../api/api';
import React, { useEffect } from 'react';
import { useDevicesStore, useObjectsStore, useUserStore } from '../stores';

export default function useAppInit() {
  const [userLoading, setUserLoading] = React.useState(true);
  const [dataLoading, setDataLoading] = React.useState(true);
  const { getObjects } = useObjectsStore();
  const { getGroupDevices } = useDevicesStore();
  const { authorized, setAuthorized, setUser } = useUserStore();

  React.useEffect(() => {
    const fetchData = async () => {
      await getUserApi(
        (data) => {
          setUser(data);
          setAuthorized(true);
          setUserLoading(false);
        },
        () => {
          setAuthorized(false);
          setUserLoading(false);
        }
      );
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setDataLoading(true);
      if (authorized) {
        try {
          await Promise.all([getGroupDevices(), getObjects()]);
        } finally {
          setDataLoading(false);
        }
      }
    };

    fetchData();
  }, [authorized]);

  const loading = userLoading || (authorized && dataLoading);

  return { loading };
}
